__turbopack_context__.v({
  "hint": "iPIH4G_hint",
  "icon": "iPIH4G_icon",
  "phrase": "iPIH4G_phrase",
  "trigger": "iPIH4G_trigger",
});
